import React from "react";
import ContentSection from "../Components/privacy-policy/ContentSection";

const PrivacyPolicy = () => {
  return <ContentSection />;
};

export default PrivacyPolicy;
